import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Space, Row, Col, Button, Alert, Switch, Modal, Image } from "antd";
import { SelectCustomCarreras } from "../componentes/selectComponentCarrera";
import { SelectCustom } from "../componentes/selectComponent";
import { SelectCustomPiloto } from "../componentes/selectComponentPiloto";
import { SelectCampeonatosResultado } from "../componentes/selectCampeonatoResultado";
import { manejarError } from "../manejo_errores";
import { HeadersAuth } from "../funciones_utiles"; // Import HeadersAuth
import { InputCustom } from "../componentes/inputComponent";
import { TablaCompleta } from "../tablas/tabla_simple";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaRegTrashAlt, FaTimes } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { CheckCircleOutlined, EditOutlined, NotificationOutlined, PlusCircleOutlined, SwapOutlined, FilePdfOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import ModalInvitado from "../componentes/modalInvitado";
import { ModalNotificacion } from "../componentes/modalNotificacion";
import ModalCubiertas from "../componentes/ModalCubiertas";
import ModalPrecintos from "../componentes/ModalPrecintos";
import moment from "moment";
import ruedaAzul from "../rueda-azul.png";

export const AltaResultados = ({ sesion, setAlerta}) => {
  const MySwal = withReactContent(Swal);
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  // Estados del componente
  const [carreras, setCarreras] = useState([]);
  const [pilotos, setPilotos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [campeonato, setCampeonato] = useState([]);
  const [bloquearForm, setBloquearForm] = useState(true);
  const [idCarreraSeleccionada, setIdCarreraSeleccionada] = useState("");
  const [idCategoriaSeleccionada, setIdCategoriaSeleccionada] = useState("");
  const [inscripcionesEditadas, setInscripcionesEditadas] = useState([]);
  const [detalleEditado, setDetalleEditado] = useState({}); // Desglose de puntos editado, indexado por id_piloto-id_categoria-id_carrera
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    id_piloto: "",
    id_categoria: "",
    numero_piloto: "",
  });
  const [fetchDatos, setFetchDatos] = useState([]); // Add setFetchDatos
  const [campeonatoSeleccionado, setCampeonatoSeleccionado] = useState(null);
  const [carrerasFiltradas, setCarrerasFiltradas] = useState([]);
  const [carreraInvitado, setCarreraInvitado] = useState(false);
  const [cateNombre, setCateNombre] = useState("");
  const [abrirModalInvitado, setAbrirModalInvitado] = useState(false);
  const [idPiloto, setIdPiloto] = useState("");
  const [noInvitados, setNoInvitados] = useState([]);
  const [cambio, setCambio] = useState(false);
  const [cambioUrl, setCambioUrl] = useState(false);
  const [modalPuntajeAutomatico, setModalPuntajeAutomatico] = useState(false);
  const [url, setUrl] = useState({
    url: "",
  });
  const [abrirModalNotificacion, setAbrirModalNotificacion] = useState(false);
  const [inscripcionesId, setInscripcionesId] = useState(null);
  const [inscripcionesTotalId, setInscripcionesTotalId] = useState(null);
  const [dataNotificacion, setDataNotificacion] = useState([]);
  const [requiereNotificacion, setRequiereNotificacion] = useState(false);
  const [openModalCubiertas, setOpenModalCubiertas] = useState(false);
  const [contextoCubiertas, setContextoCubiertas] = useState(null);
  const [openModalPrecintos, setOpenModalPrecintos] = useState(false);
  const [contextoPrecintos, setContextoPrecintos] = useState(null);
  const [modalVerInvitado, setModalVerInvitado] = useState(false);
  const [invitadoSeleccionado, setInvitadoSeleccionado] = useState(null);
  const [inscripcionInvitadoSeleccionada, setInscripcionInvitadoSeleccionada] = useState(null);

  // const [carrerasOpciones, setCarrerasOpciones] = useState([]);
  useEffect(() => {
    if (cambio) {
      fetchPilotos(sesion.id_asociacion, idCarreraSeleccionada, idCategoriaSeleccionada);
      fetchInscripcionesFiltradas();
      setCambio(false);
      // console.log("adjnsndlakndkjwan")
    }
  }, [cambio]);

  // Carga inicial de datos
  useEffect(() => {
    fetchCampeonato(sesion.id_asociacion);
  }, [sesion.id_asociacion]);

  const fetchCampeonato = async (id_asociacion) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/campeonato/asociacion/${id_asociacion}`);
      const campeonatosConLabel = response.data.map((c) => ({
        ...c,
        label: `${c.nombre_campeonato} (${c.año})`,
      }));
      setCampeonato(campeonatosConLabel);

      const ultimoCampeonato = response.data.reduce((prev, curr) =>
        prev.año > curr.año || (prev.año === curr.año && prev.id > curr.id) ? prev : curr
      );
      // Establecer el campeonato seleccionado
      setCampeonatoSeleccionado(ultimoCampeonato.id);

   
        fetchCarreras(id_asociacion, ultimoCampeonato.id)
 
    } catch (error) {
      manejarAlertas("error", "Error al obtener el campeonato");
    };
  };

  // Obtener carreras
  const fetchCarreras = async (id_asociacion, id_campeonato) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/carrera/asociacion/${id_asociacion}`
      );
      // console.log("el campeonato seleccionado", campeonatoSeleccionado)
      const filtro = response.data.filter(carrera => carrera.id_campeonato == id_campeonato);
      setCarrerasFiltradas(filtro);
      // console.log("carreras", response.data)
     
    } catch (error) {
      manejarAlertas("error","Error al obtener carreras.");

      console.error("Error al obtener carreras:", error);
    }
  };

  // Obtener pilotos
  const fetchPilotos = async (id_asociacion, id_carrera, id_categoria) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/pilotos-no-inscritos/${id_asociacion}/${id_carrera}/${id_categoria}`
      );
      const { pilotosNoInscritos, pilotosNoInvitados } = response.data;
      setPilotos(pilotosNoInscritos);
      // console.log("fetchPilotos")
      setNoInvitados(pilotosNoInvitados);
    } catch (error) {
      manejarAlertas("error","Error al obtener pilotos.");

      console.error("Error al obtener pilotos:", error);
    }
  };

  // Obtener categorías por carrera
  const fetchCategoriasPorCarrera = async (id_carrera) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/categorias-por-carrera/${id_carrera}`,
        HeadersAuth
      );
      setCategorias(response.data);
    } catch (error) {
      manejarAlertas("error","Error al obtener categorías.");
      console.error("Error al obtener categorías:", error);
    }
  };

  // Obtener inscripciones filtradas
  const fetchInscripcionesFiltradas = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/filtrar`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_carrera: idCarreraSeleccionada,
            id_categoria: idCategoriaSeleccionada,
          },
          ...HeadersAuth,
        }
      );
      // console.log("data", response.data)
      const hayInvitados = response.data
        .map(car => car.carrera)                
        .flatMap(c => c.CarreraCategoria)      
        .filter(cat => cat.invitado === true)
        .find(cat => cat.id_categoria === parseInt(idCategoriaSeleccionada)) ? true : false;

      const categoriaNombre = response.data
        .map(car => car.categoria)              
        .find(cat => cat.id === parseInt(idCategoriaSeleccionada))?.categoria; 

      // console.log("invitados", hayInvitados);

      setCateNombre(categoriaNombre);
      setCarreraInvitado(hayInvitados);
      // console.log("mejecutoiooo");

      setFetchDatos([]); // limpia para forzar render
      setTimeout(() => {
        setFetchDatos([...response.data]); // nueva referencia
      }, 0);

      // console.log("inscripciones", response.data)
    } catch (error) {
      manejarAlertas("error","Error al obtener inscripciones.");

      console.error("Error al obtener inscripciones:", error);
    }
  };

  const limpiarCampos = () => {
    setTempDatosFormulario({
      id_piloto: "",
      id_categoria: "",
      numero_piloto: "",
    });

    setMostrarBotonLimpiar(false);
  };

  //manejo de select-campeonato
  const handleCampeonatoChange = (e,id_asociacion) => {
    const idCampeonato = e.target.value;
    setCampeonatoSeleccionado(idCampeonato);
    setIdCarreraSeleccionada(null);
    setInscripcionesEditadas([]);
    setFetchDatos([]); // Limpiar inscripciones

    fetchCarreras(id_asociacion,idCampeonato)

  };

  const abrirModalVerInvitado = (inscripcion) => {
    setInvitadoSeleccionado(inscripcion.pilotoInvitado);
    setInscripcionInvitadoSeleccionada(inscripcion);
    setModalVerInvitado(true);
  };

  // Manejo del cambio en el select de carreras
  const handleCarreraChange = (e) => {
    const idCarrera = e.target.value;
    setIdCarreraSeleccionada(idCarrera);
    setIdCategoriaSeleccionada(null); // Reiniciar categoría al cambiar de carrera
    setFetchDatos([]); // Limpiar inscripciones
    setInscripcionesEditadas([]);
    setCarreraInvitado(false);
    setBloquearForm(true);
    if (idCarrera) {
      fetchCategoriasPorCarrera(idCarrera); // Cargar categorías para la carrera seleccionada
    }
  };

  // Manejo del cambio en el select de categorías
  const handleCategoriaChange = async (e) => {
    const idCategoria = e.target.value;
    setIdCategoriaSeleccionada(idCategoria);
    setInscripcionesEditadas([]);
  };

  useEffect(() => {
    if (idCategoriaSeleccionada && idCarreraSeleccionada && campeonatoSeleccionado) {
      fetchInscripcionesFiltradas();
      fetchPilotos(
        sesion.id_asociacion,
        idCarreraSeleccionada,
        idCategoriaSeleccionada
      );
    }
  }, [sesion.id_asociacion, campeonatoSeleccionado, idCategoriaSeleccionada, idCarreraSeleccionada]);

  // Manejo de cambios en el formulario
  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleEditar = () => {
    if (bloquearForm) {
      setBloquearForm(false);
    }
  };

  useEffect(() => {
    if (campeonatoSeleccionado && idCarreraSeleccionada && idCategoriaSeleccionada) {
      fetchRequiereNotis();
    }
  }, [campeonatoSeleccionado, idCarreraSeleccionada, idCategoriaSeleccionada]);

  const fetchRequiereNotis = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/enviar-notificacion`,
        {
          id_campeonato: campeonatoSeleccionado,
          id_carrera: idCarreraSeleccionada,
          id_categoria: idCategoriaSeleccionada,
        },
        HeadersAuth,
      );
      setRequiereNotificacion(response.data.requiereNotificacion);
    } catch (error) {
      manejarAlertas("error",manejarError(error));
    }
  }

  const handleEnviarNotificacion = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/enviar-notificacion`,
        {
          id_campeonato: campeonatoSeleccionado,
          id_carrera: idCarreraSeleccionada,
          id_categoria: idCategoriaSeleccionada,
        },
        HeadersAuth,
      );
      // console.log("response noti", response.data.requiereNotificacion);
      if (response.data.requiereNotificacion) {
        setAbrirModalNotificacion(true)
        setDataNotificacion(response.data.notificacionSistema);
      }

    } catch (error) {
      manejarAlertas("error",manejarError(error));
    }
  }

  // Crear una nueva inscripción
  const crearInscripcion = async () => {
    try {
      const payload = {
        id_piloto: parseInt(tempDatosFormulario.id_piloto),
        id_categoria: parseInt(idCategoriaSeleccionada),
        id_carrera: parseInt(idCarreraSeleccionada),
        numero_piloto: tempDatosFormulario.numero_piloto || null,
      };

      const response = await axios.post(`${process.env.REACT_APP_DOMINIO}/inscripcion-piloto`, payload);

      manejarAlertas("success","Inscripción creada exitosamente.");
      fetchInscripcionesFiltradas(); // Refrescar la lista de inscripciones
      setTempDatosFormulario({
        id_piloto: "",
        id_categoria: "",
        numero_piloto: "",
      });

      if (response.data.requiereNotificacion) {
        setAbrirModalNotificacion(true)
        setDataNotificacion(response.data.notificacionSistema);
      }

      fetchPilotos(sesion.id_asociacion, idCarreraSeleccionada, idCategoriaSeleccionada);
    } catch (error) {
      manejarAlertas("error",manejarError(error));

    }
  };

  // Manejar cambios en los inputs editables
  const handleInputChange = (
    id_piloto,
    id_categoria,
    id_carrera,
    field,
    value
  ) => {
    // console.log(typeof value)
    // console.log("Cambios", inscripcionesEditadas);
    const updatedInscripciones = inscripcionesEditadas.map((inscripcion) =>
      inscripcion.id_piloto === id_piloto &&
        inscripcion.id_categoria === id_categoria &&
        inscripcion.id_carrera === id_carrera
        ? { ...inscripcion, [field]: (value === "" || value === 0) ? "" : value }
        : inscripcion
    );

    // Si no existe, agregar la inscripción al estado
    if (
      !updatedInscripciones.some(
        (ins) =>
          ins.id_piloto === id_piloto &&
          ins.id_categoria === id_categoria &&
          ins.id_carrera === id_carrera
      )
    ) {
      updatedInscripciones.push({
        id_piloto,
        id_categoria,
        id_carrera,
        [field]: value,
      });
    }
    setInscripcionesEditadas(updatedInscripciones);
  };

  const handleSwitchChange = (id_piloto, id_categoria, id_carrera, value) => {
    const updatedInscripciones = inscripcionesEditadas.map((inscripcion) =>
      inscripcion.id_piloto === id_piloto &&
      inscripcion.id_categoria === id_categoria &&
      inscripcion.id_carrera === id_carrera
        ? { ...inscripcion, asistencia: value }
        : inscripcion
    );

    // Si no existe, agregar la inscripción al estado
    if (
      !updatedInscripciones.some(
        (ins) =>
          ins.id_piloto === id_piloto &&
          ins.id_categoria === id_categoria &&
          ins.id_carrera === id_carrera
      )
    ) {
      updatedInscripciones.push({
        id_piloto,
        id_categoria,
        id_carrera,
        asistencia: value,
      });
    }

    setInscripcionesEditadas(updatedInscripciones);
  };

  // Clave para indexar el desglose de puntos editado de una inscripción
  const claveInscripcion = (id_piloto, id_categoria, id_carrera) =>
    `${id_piloto}-${id_categoria}-${id_carrera}`;

  // Maneja la edición de un ítem del desglose de puntos (sin disparar request, queda en detalleEditado)
  const handleDetalleChange = (a, itemId, value) => {
    const key = claveInscripcion(a.id_piloto, a.id_categoria, a.id_carrera);
    setDetalleEditado((prev) => {
      const actual = prev[key] || (a.puntosDetalle || []).map((item) => ({ ...item }));
      return {
        ...prev,
        [key]: actual.map((item) =>
          item.id === itemId ? { ...item, puntos: value } : item
        ),
      };
    });
  };

  const refrescarTabla = async () => {
    await fetchInscripcionesFiltradas();
    setInscripcionesEditadas([]);
    setDetalleEditado({});
  };


  const guardarCambios = async () => {
    try {
      const bulkUpdatePromise = axios.post(
        `${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/bulk-update`,
        { inscripciones: inscripcionesEditadas },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      const detallePuntosPromises = Object.entries(detalleEditado).map(
        ([key, detalle]) => {
          const [id_piloto, id_categoria, id_carrera] = key.split("-");
          return axios.put(
            `${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/detalle-puntos`,
            {
              id_piloto: Number(id_piloto),
              id_categoria: Number(id_categoria),
              id_carrera: Number(id_carrera),
              detalle: detalle.map((item) => ({
                id: item.id,
                puntos: parseFloat(item.puntos),
              })),
            },
            HeadersAuth
          );
        }
      );

      await Promise.all([bulkUpdatePromise, ...detallePuntosPromises]);

      manejarAlertas("success", "Cambios guardados correctamente.");
      await refrescarTabla();
      setBloquearForm(true); // Bloquea el formulario después de guardar
    } catch (error) {
      manejarAlertas("error",manejarError(error));


    }
  };
  const handleEliminarInscripcion = (id_piloto, id_categoria, id_carrera) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/pre-eliminar/${id_piloto}/${id_categoria}/${id_carrera}`,
            HeadersAuth
          );
          // Si requiere notificación → abrir modal ANTES de eliminar
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true);
            setDataNotificacion(response.data.notificacionSistema); 

            // Guardamos ID para eliminar luego
            setInscripcionesId({
              id_piloto: id_piloto,
              id_categoria: id_categoria,
              id_carrera: id_carrera,
            });
            return;
          }

          // Si NO requiere notificación → eliminar directamente
          await eliminarInscripcion(id_piloto, id_categoria, id_carrera);
        } catch (error) {
          manejarAlertas("error",manejarError(error));
        }
      }
    });
  };

  useEffect(() => {
    if (!abrirModalNotificacion && inscripcionesId) {
      eliminarInscripcion(inscripcionesId.id_piloto, inscripcionesId.id_categoria, inscripcionesId.id_carrera);
      setInscripcionesId(null);
    }
  }, [abrirModalNotificacion]);

  const eliminarInscripcion = async (id_piloto, id_categoria, id_carrera) => {
    try {
      // console.log("id que se envía", id_piloto, id_categoria, id_carrera)
      const response = await axios.delete(
        `${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/${id_piloto}/${id_categoria}/${id_carrera}`,
        HeadersAuth
      );

      manejarAlertas("success", "El piloto ha sido eliminado.");
      fetchInscripcionesFiltradas();
    } catch (error) {
      console.error("Error al eliminar el piloto:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleEliminarTodasInscripciones = (id_piloto, id_categoria, campeonatoSeleccionado) => {
    MySwal.fire({
      title: "¿Estás seguro de eliminar todas las inscripciones de este piloto en esta categoría?",
      text: "Esta acción no se puede deshacer. Se eliminará la inscripción y los puntos de este piloto en esta categoría.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DOMINIO}/inscripcion-piloto/pre-eliminar-total/${id_piloto}/${id_categoria}/${campeonatoSeleccionado}`,
            HeadersAuth
          );

          // Si requiere notificación → abrir modal ANTES de eliminar
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true);
            setDataNotificacion(response.data.notificacionSistema); 

            // Guardamos ID para eliminar luego
            setInscripcionesTotalId({
              id_piloto: id_piloto,
              id_categoria: id_categoria,
              campeonatoSeleccionado: campeonatoSeleccionado,
            });
            return;
          }

          // Si NO requiere notificación → eliminar directamente
          await eliminarInscripcionTotal(id_piloto, id_categoria, campeonatoSeleccionado);
        } catch (error) {
          manejarAlertas("error",manejarError(error));
        }
      }
    });
  };

  useEffect(() => {
    if (!abrirModalNotificacion && inscripcionesTotalId) {
      eliminarInscripcionTotal(inscripcionesTotalId.id_piloto, inscripcionesTotalId.id_categoria, inscripcionesTotalId.campeonatoSeleccionado);
      setInscripcionesTotalId(null);
    }
  }, [abrirModalNotificacion]);

  const eliminarInscripcionTotal = async (id_piloto, id_categoria, campeonatoSeleccionado) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_DOMINIO}/inscripcion-piloto-total/${id_piloto}/${id_categoria}/${campeonatoSeleccionado}`,
        HeadersAuth
      );

      manejarAlertas("success", "La inscripción ha sido eliminada.");
      fetchInscripcionesFiltradas();
    } catch (error) {
      console.error("Error al eliminar la inscripción:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  const desasignarInvitado = async (id_piloto_invitado, id_piloto) => {
    try {
      const payload = {
        id_piloto: parseInt(id_piloto),
        id_piloto_invitado: parseInt(id_piloto_invitado),
        id_categoria: parseInt(idCategoriaSeleccionada),
        id_carrera: parseInt(idCarreraSeleccionada),
      };
      // console.log("lo que se envía des", payload)
      await axios.post(`${process.env.REACT_APP_DOMINIO}/desasignar-invitado`, payload, HeadersAuth);
      manejarAlertas("success","Se ha desasignado al piloto exitosamente.");
      fetchInscripcionesFiltradas();
      fetchPilotos(sesion.id_asociacion, idCarreraSeleccionada, idCategoriaSeleccionada);
    } catch (error) {
      manejarAlertas("error",manejarError(error));
    }
  };

  // Handle url puntaje automático
  const handleUrl = async () => {
    try {
      const payload = {
        url: url.url,
        id_categoria: parseInt(idCategoriaSeleccionada),
        id_carrera: parseInt(idCarreraSeleccionada),
      }
      // console.log("lo que se envía:", payload);
      const response = await axios.post(`${process.env.REACT_APP_DOMINIO}/puntaje-url`,
        payload,
        HeadersAuth
      )
      // console.log("lo que vuelve", response.data)
      if (response.status == 200) {
        await refrescarTabla();
        setModalPuntajeAutomatico(false);
        MySwal.fire({
          title: "Puntos asignados con éxito",
          text: "El puntaje ha sido asignado correctamente.",
          icon: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        setUrl({
          url: "",
        })
      }
    } catch (error) {
      MySwal.fire({
        title: "Error al asignar puntos",
        text: "No se pudo asignar el puntaje. Por favor, inténtelo de nuevo.",
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Aceptar",
      })
      console.error("Error al obtener el puntaje:", error);
    }
  }

  const onChangeUrl = (e) => {
    setUrl({
      ...url,
      url: e.target.value,
    });
  };

  const categoriaActual = fetchDatos?.find(
    (item) => Number(item.id_categoria) === Number(idCategoriaSeleccionada)
  );

  //columnas Tabla
  const elScroll = { x: 0 };
  const columns = [
    {
      title: "NÚMERO",
      key: "numero_piloto",
      align: "left",
      width: 90,
      sorter: (a, b) => a.numero_piloto - b.numero_piloto,
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          <input
            type="number"
            style={{ textAlign: "right", width: "100%" }}
            value={
              inscripcionesEditadas.find(
                (ins) =>
                  ins.id_piloto === a.id_piloto &&
                  ins.id_categoria === a.id_categoria &&
                  ins.id_carrera === a.id_carrera
              )?.numero_piloto ??
              a.numero_piloto ??
              ""
            }
            disabled={bloquearForm}
            onChange={(e) =>
              handleInputChange(
                a.id_piloto,
                a.id_categoria,
                a.id_carrera,
                "numero_piloto",
                e.target.value
              )
            }
          />
        </div>
      ),
    },
    {
      title: "PILOTO",
      key: "nombre",
      align: "left",
      render: (a) => {
        return (
          <div style={{ fontSize: "14px", padding: "3px 6px" }}>
            {a.piloto.apellido}, {a.piloto.nombre}

            {carreraInvitado !== false && (
              a.pilotoInvitado !== null ? (
                <CheckCircleOutlined
                  title="Ver invitado"
                  style={{
                    marginLeft: 6,
                    color: "#008000",
                    cursor: "pointer",
                    fontSize: 16,
                  }}
                  onClick={() => abrirModalVerInvitado(a)}
                />
              ) : (
                <PlusCircleOutlined
                  title="Agregar invitado"
                  style={{
                    marginLeft: 6,
                    color: "#BA1721",
                    cursor: "pointer",
                    fontSize: 16,
                  }}
                  onClick={() => handleInvitarPiloto(a.id_piloto)}
                />
              )
            )}
          </div>
        );
      },
    },
    {
      title: "ASISTENCIA",
      key: "asistencia",
      align: "left",
      sorter: (a, b) => a.asistencia - b.asistencia,
      render: (a) => (
        <Switch
          checked={
            inscripcionesEditadas.find(
              (ins) =>
                ins.id_piloto === a.id_piloto &&
                ins.id_categoria === a.id_categoria &&
                ins.id_carrera === a.id_carrera
            )?.asistencia ?? a.asistencia ?? false
          }
          checkedChildren="SI"
          unCheckedChildren="NO"
          onChange={(value) =>
            handleSwitchChange(a.id_piloto, a.id_categoria, a.id_carrera, value)
          }
          disabled={bloquearForm}
          style={{
            backgroundColor:
              (inscripcionesEditadas.find(
                (ins) =>
                  ins.id_piloto === a.id_piloto &&
                  ins.id_categoria === a.id_categoria &&
                  ins.id_carrera === a.id_carrera
              )?.asistencia ?? a.asistencia)
                ? "#223463"
                : "#BA1721",
          }}
        />
      ),
    },
    {
      title: "POSICIÓN",
      key: "posicion",
      align: "left",
      width: 90,
      sorter: (a, b) => a.posicion - b.posicion,
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", justifyContent: "flex-end" }}>
          <input
            style={{ textAlign: "right", width: "80%" }}
            type="number"
            value={
              inscripcionesEditadas.find(
                (ins) =>
                  ins.id_piloto === a.id_piloto &&
                  ins.id_categoria === a.id_categoria &&
                  ins.id_carrera === a.id_carrera
              )?.posicion ?? a.posicion ?? ""
            }
            disabled={bloquearForm}
            onChange={(e) =>
              handleInputChange(
                a.id_piloto,
                a.id_categoria,
                a.id_carrera,
                "posicion",
                e.target.value
              )
            }
          />
        </div>
      ),
    },
    {
      title: "PUNTOS",
      key: "puntos",
      align: "left",
      sorter: (a, b) => a.puntos - b.puntos,
      render: (a) => {
        const tieneDesglose = a.puntosDetalle && a.puntosDetalle.length > 0;

        if (!tieneDesglose) {
          return (
            <div style={{ fontSize: "12px", padding: "2px 4px", justifyContent: "flex-end", display: "flex", alignItems: "center" }}>
              <input
                style={{ textAlign: "right", width: "80%" }}
                type="number"
                value={
                  inscripcionesEditadas.find(
                    (ins) =>
                      ins.id_piloto === a.id_piloto &&
                      ins.id_categoria === a.id_categoria &&
                      ins.id_carrera === a.id_carrera
                  )?.puntos ??
                  a.puntos ??
                  "0"
                }
                disabled={bloquearForm}
                onChange={(e) =>
                  handleInputChange(
                    a.id_piloto,
                    a.id_categoria,
                    a.id_carrera,
                    "puntos",
                    e.target.value
                  )
                }
              />
            </div>
          );
        }

        const key = claveInscripcion(a.id_piloto, a.id_categoria, a.id_carrera);
        const detalleActual = detalleEditado[key] || a.puntosDetalle;
        const total = detalleActual.reduce(
          (acc, item) => acc + (parseFloat(item.puntos) || 0),
          0
        );

        return (
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6, padding: "2px 4px", minWidth: 170 }}>
            {detalleActual.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  fontSize: 13,
                  background: "#f0f0f0",
                  borderRadius: 4,
                  padding: "3px 7px",
                }}
              >
                <span>{item.tipo}:</span>
                {bloquearForm ? (
                  <span>{item.puntos}</span>
                ) : (
                  <input
                    type="number"
                    style={{ width: 46, textAlign: "right", fontSize: 13 }}
                    value={item.puntos}
                    onChange={(e) => handleDetalleChange(a, item.id, e.target.value)}
                  />
                )}
              </div>
            ))}
            <span style={{ fontSize: "12px", fontWeight: "bold", marginLeft: "auto" }}>
              {total}
            </span>
          </div>
        );
      },
    },

    {
      title: "ACCIONES",
      key: "acciones",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 10 }}>
          {categoriaActual?.categoria?.limiteCubiertas && (
            <img
              src={ruedaAzul}
              alt="Cubiertas"
              title="Cubiertas"
              style={{ width: 20, height: 20, cursor: "pointer" }}
              onClick={() => {
                setContextoCubiertas({
                  id_piloto: record.id_piloto,
                  id_categoria: record.id_categoria,
                  id_carrera: record.id_carrera,
                  pilotoNombre: `${record.piloto?.apellido || ""}, ${record.piloto?.nombre || ""}`,
                });
                setOpenModalCubiertas(true);
              }}
            />
          )}
          {categoriaActual?.categoria?.cargaPrecintos && (
            <SafetyCertificateOutlined
              title="Precintos"
              style={{ fontSize: 20, cursor: "pointer", color: "#233463" }}
              onClick={() => {
                setContextoPrecintos({
                  id_piloto: record.id_piloto,
                  id_categoria: record.id_categoria,
                  id_carrera: record.id_carrera,
                  pilotoNombre: `${record.piloto?.apellido || ""}, ${record.piloto?.nombre || ""}`,
                });
                setOpenModalPrecintos(true);
              }}
            />
          )}
          <FaRegTrashAlt
            title="Eliminar inscripción de esta carrera"
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
            onClick={() =>
              handleEliminarInscripcion(
                record.id_piloto,
                record.id_categoria,
                record.id_carrera
              )
            }
          />
          <FaTimes
            title="Eliminar todas las inscripciones de este piloto en esta categoría"
            className="iconos-tablas"
            style={{ color: "#233463", cursor: "pointer" }}
            onClick={() =>
              handleEliminarTodasInscripciones(
                record.id_piloto,
                record.id_categoria,
                campeonatoSeleccionado
              )
            }
          />
        </div>
      ),
    },
  ].filter(Boolean);

  const getUrlLicenciaInvitado = (licencia, archivo) => {
    if (!licencia || !archivo) return null;

    return `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${licencia.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${licencia.id_campeonato}/piloto_${licencia.id_piloto}/${archivo}`;
  };

  const handleInvitarPiloto = (idPiloto) => {
    setIdPiloto(idPiloto)
    setAbrirModalInvitado(true)
  }
  const esTelefono = useMediaQuery({ maxWidth: 768 });

  return (
    <>
     
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        {" "}
        <h1 className="titulos">Gestión de Carreras</h1>
      </section>

      {/* Formulario */}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {/* Datos de la carrera */}
        <div
          className="contendor-card-carreras"
          style={{
            width: "auto",
            width: "800px",
            padding: "20px",
            border: "1px solid #bbbbbb",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <h1 className="titulos-secundarios">Datos de la carrera</h1>
            {mostrarBotonLimpiar && (
              <BotonPrincipal texto="Nueva carrera" onClick={limpiarCampos} />
            )}
          </div>
          <hr />
          <Row align="middle" justify={"center"} >
            <Col
              xs={24} sm={12} md={8}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: "0 10px"
              }}
            >
              <Form.Item
              style={{ width:"100%" }}>
                <SelectCampeonatosResultado
                  idCampo={"id_campeonato"}
                  nombreCampo={"Campeonato"}
                  elPlaceholder="Seleccione un campeonato"
                  arrayOpciones={campeonato.length > 0 ? campeonato : []} // Debe ser los campeonatos de la categoría activa
                  textoOpciones="label"
                  onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                  elValue={campeonatoSeleccionado} // Valor seleccionado por defecto
                />
              </Form.Item>
            </Col>
            <Col
                xs={24} sm={12} md={8}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  padding: "0 10px"
                }}
              >
                <Form.Item
                style={{ width: "100%" }}>
                  <SelectCustomCarreras
                    idCampo={"id_carrera"}
                    nombreCampo={"Carreras"}
                    elPlaceholder={"Seleccioná una carrera"}
                    arrayOpciones={carrerasFiltradas.length > 0 ? carrerasFiltradas : []}
                    required={false}
                    onChange={handleCarreraChange}
                    elValue={idCarreraSeleccionada}
                  />
                </Form.Item>
            </Col>
            {idCarreraSeleccionada ? (
              <Col
                xs={24} sm={12} md={8}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  padding: "0 10px"
                }}
              >
                <Form.Item style={{ height: "100%" }}>
                    <SelectCustom
                      idCampo={"id_categoria"}
                      nombreCampo={"Categorias"}
                      elPlaceholder={"Seleccioná una categoria"}
                      arrayOpciones={categorias.length > 0 ? categorias : []}
                      required={true}
                      onChange={handleCategoriaChange}
                      textoOpciones={"categoria"}
                      elValue={idCategoriaSeleccionada}
                    />
                </Form.Item>
              </Col>
              ) : null}
          </Row>
        </div>
        {carreraInvitado !== false && (
          <h1 
            style={{
              fontSize: 24,
              fontWeight: "lighter",
              color: "#233463",
              textAlign: "center"
            }}
          >Carrera con invitado ({cateNombre})</h1>
        )}
        {/* Nueva Inscripción */}
        {idCarreraSeleccionada && idCategoriaSeleccionada && (
          <div
            className="contendor-card-carreras"
            style={{
              width: "auto",
              width: "800px",
              padding: "20px",
              border: "1px solid #bbbbbb",
              borderRadius: "10px",
            }}
          >
            <h1 className="titulos-secundarios">Nueva Inscripción</h1>
            <hr />
            <Form layout="vertical" onFinish={crearInscripcion}>
              <Row gutter={24} align="middle">
                <Col xs={24} sm={9}>
                  <Form.Item style={{ width: "100%" }}>
                    <SelectCustomPiloto
                      idCampo={"id_piloto"}
                      nombreCampo={"Pilotos"}
                      elPlaceholder={"Seleccioná un piloto"}
                      arrayOpciones={pilotos.length > 0 ? pilotos : []}
                      required={true}
                      onChange={handleChange}
                      elValue={tempDatosFormulario.id_piloto || ""}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={9}>
                  <Form.Item style={{ width: "100%" }}>
                    <InputCustom
                      tipo="number"
                      nombreCampo="Número de piloto"
                      idCampo="numero_piloto"
                      elPlaceholder="Ingrese el numero del piloto"
                      elValue={tempDatosFormulario.numero_piloto || ""}
                      onChange={handleChange}
                      required={false}
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="boton-principal"
                    style={{ width: "100%", marginTop: "21px"}}
                  >
                    Inscribir
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        )}{" "}
      </section>

      {/* Lista de Inscripciones */}
      {fetchDatos.length > 0 && (
        <div
          className="botonDescargar"
          style={{
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "flex-start",
            padding:"0 16px",
          }}
        >
          <h1 className="titulos-secundarios ">
            Inscripciones / Resultados Carreras
          </h1>

          <TablaCompleta
            tituloPDF={"resultados_inscripciones"}
            elScroll={elScroll}
            columns={columns}
            filasPorPagina={60}
            fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
            rowKey={"id_piloto"}
            gestionTabla={
              <Row style={{ gap: "10px" }}>
                {!bloquearForm && (
                  <BotonPrincipal
                    texto="Guardar Cambios"
                    onClick={guardarCambios}
                  />
                )}
                {bloquearForm && (
                  <BotonPrincipal
                    texto={esTelefono ? <EditOutlined /> : "Editar"}
                    onClick={handleEditar}
                  />
                )}
                {bloquearForm && (
                  <BotonPrincipal
                    texto={esTelefono ? <SwapOutlined /> : "Poner puntaje automático"}
                    onClick={() => setModalPuntajeAutomatico(true)}
                  />
                )}
                {requiereNotificacion === true && bloquearForm && (
                  <BotonPrincipal
                    texto={esTelefono ? <NotificationOutlined /> : "Enviar notificación"}
                    onClick={handleEnviarNotificacion}
                  />
                )}
              </Row>
            }
            tituloBanner={"Inscripciones/Resultados"}
            idAsociacion={sesion.id_asociacion}
            idCategoria={idCategoriaSeleccionada}
          />
          {/*Modal para puntaje automático por URL */}
          <Modal
            title="Poner puntaje automático"
            open={modalPuntajeAutomatico}
            onCancel={() => setModalPuntajeAutomatico(false)}
            footer={null}
          >
            <Row
              gutter={16}
              style={{ justifyContent: "center", alignItems: "flex-end" }}
            >
              <Col xs={24} sm={16}>
                <InputCustom
                  tipo="text"
                  nombreCampo="Ingrese la url de la carrera"
                  idCampo="url"
                  elPlaceholder="Ingrese la url de la carrera"
                  elValue={url.url}
                  onChange={onChangeUrl}
                  required={true}
                />
              </Col>
              <Col xs={24} sm={8} style={{ alignItems: "center" }}>
                <Button
                  type="primary"
                  style={{
                    width: "100%",
                    padding: "6px 10px",
                    fontSize: "16px",
                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "#BA1721",  
                    color: "white",  
                    cursor: "pointer",
                    transition: "background-color 0.3s ease",
                  }}
                  onClick={handleUrl}
                >
                  Poner puntaje
                </Button>
              </Col>
            </Row>
          </Modal>
        <ModalInvitado
          open={abrirModalInvitado}
          onCancel={() => setAbrirModalInvitado(false)}
          idPiloto={idPiloto}
          pilotos={noInvitados}
          datosPiloto={fetchDatos}
          idCategoriaSeleccionada={idCategoriaSeleccionada}
          idCarreraSeleccionada={idCarreraSeleccionada}
          manejarAlertas={manejarAlertas}
          onCambios={() => setCambio(true)}
          idAsociacion={sesion.id_asociacion}
        />

        <Modal
          open={modalVerInvitado}
          onCancel={() => {
            setModalVerInvitado(false);
            setInvitadoSeleccionado(null);
            setInscripcionInvitadoSeleccionada(null);
          }}
          footer={null}
          centered
          width={760}
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <CheckCircleOutlined style={{ color: "#16803C", fontSize: 22 }} />
              <span>Detalle del piloto invitado</span>
            </div>
          }
        >
          {invitadoSeleccionado && (
            <div>
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div style={stylesModalInvitado.infoItem}>
                    <strong>Nombre:</strong>
                    <span>{invitadoSeleccionado.nombre}</span>
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div style={stylesModalInvitado.infoItem}>
                    <strong>Apellido:</strong>
                    <span>{invitadoSeleccionado.apellido}</span>
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div style={stylesModalInvitado.infoItem}>
                    <strong>DNI:</strong>
                    <span>{invitadoSeleccionado.dni || "-"}</span>
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div style={stylesModalInvitado.infoItem}>
                    <strong>Fecha de nacimiento:</strong>
                    <span>
                      {invitadoSeleccionado.fecha_nacimiento
                        ? moment(invitadoSeleccionado.fecha_nacimiento).format("DD/MM/YYYY")
                        : "-"}
                    </span>
                  </div>
                </Col>
              </Row>

              <hr style={{ margin: "22px 0" }} />

              <h3 style={{ marginBottom: 15, color: "#233463" }}>
                Licencia médica
              </h3>

              {(() => {
                const licencia = invitadoSeleccionado?.licenciasDeportivas?.find(
                  (lic) =>
                    Number(lic.id_campeonato) ===
                    Number(inscripcionInvitadoSeleccionada?.carrera?.id_campeonato)
                );

                if (!licencia) {
                  return (
                    <div style={stylesModalInvitado.sinLicencia}>
                      Este invitado no tiene licencia médica cargada.
                    </div>
                  );
                }

                if (licencia.tipo_archivo === "PDF" && licencia.licencia_pdf) {
                  return (
                    <div style={stylesModalInvitado.pdfCard}>
                      <FilePdfOutlined style={{ fontSize: 42, color: "#BA1721" }} />

                      <div style={{ flex: 1 }}>
                        <p style={{ margin: 0, fontWeight: 600 }}>
                          PDF de licencia cargado
                        </p>
                        <p style={{ margin: 0, color: "#777", fontSize: 13 }}>
                          {licencia.licencia_pdf}
                        </p>
                      </div>

                      <Button
                        href={getUrlLicenciaInvitado(licencia, licencia.licencia_pdf)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          backgroundColor: "#BA1721",
                          color: "#fff",
                          fontSize: 16
                        }}
                      >
                        Ver PDF
                      </Button>
                    </div>
                  );
                }

                if (
                  licencia.tipo_archivo === "IMAGENES" &&
                  licencia.foto_frente &&
                  licencia.foto_dorso
                ) {
                  return (
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={12}>
                        <div style={stylesModalInvitado.licenciaCard}>
                          <p style={stylesModalInvitado.licenciaTitulo}>Frente</p>
                          <Image
                            src={getUrlLicenciaInvitado(licencia, licencia.foto_frente)}
                            alt="Frente licencia médica"
                            width="100%"
                            height={220}
                            style={stylesModalInvitado.licenciaImagen}
                          />
                        </div>
                      </Col>

                      <Col xs={24} md={12}>
                        <div style={stylesModalInvitado.licenciaCard}>
                          <p style={stylesModalInvitado.licenciaTitulo}>Dorso</p>
                          <Image
                            src={getUrlLicenciaInvitado(licencia, licencia.foto_dorso)}
                            alt="Dorso licencia médica"
                            width="100%"
                            height={220}
                            style={stylesModalInvitado.licenciaImagen}
                          />
                        </div>
                      </Col>
                    </Row>
                  );
                }

                return (
                  <div style={stylesModalInvitado.sinLicencia}>
                    La licencia médica está incompleta.
                  </div>
                );
              })()}

              <Row gutter={16} justify="end" style={{ marginTop: 25 }}>
                <Col xs={24} sm={12}>
                  <Button
                    style={{
                      width: "100%",
                      backgroundColor: "#233463",
                      color: "#FFF",
                      fontSize: 16,
                    }}
                    onClick={() => {
                      setModalVerInvitado(false);
                      setInvitadoSeleccionado(null);
                      setInscripcionInvitadoSeleccionada(null);
                    }}
                  >
                    Cerrar
                  </Button>
                </Col>

                <Col xs={24} sm={12}>
                  <Button
                    style={{
                      width: "100%",
                      backgroundColor: "#BA1721",
                      color: "#FFF",
                      fontSize: 16,
                    }}
                    onClick={() => {
                      desasignarInvitado(
                        inscripcionInvitadoSeleccionada.id_pilotoInvitado,
                        inscripcionInvitadoSeleccionada.id_piloto
                      );

                      setModalVerInvitado(false);
                    }}
                  >
                    Desasignar invitado
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </Modal>

        <ModalCubiertas
          open={openModalCubiertas}
          onClose={() => setOpenModalCubiertas(false)}
          contexto={contextoCubiertas}
          onGuardado={refrescarTabla}
          MySwal={MySwal}
        />

        <ModalPrecintos
          open={openModalPrecintos}
          onClose={() => setOpenModalPrecintos(false)}
          contexto={contextoPrecintos}
          onGuardado={refrescarTabla}
          manejarAlertas={manejarAlertas}
        />
        </div>
      )}

      {dataNotificacion.length > 0 && (
        <ModalNotificacion
          open={abrirModalNotificacion}
          onCancel={() => setAbrirModalNotificacion(false)}
          datos={dataNotificacion}
          id_asociacion={sesion.id_asociacion}
          HeadersAuth={HeadersAuth}
          setAlerta={setAlerta}
        />
      )}
    </>
  );
};

const stylesModalInvitado = {
  infoItem: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    padding: "10px 12px",
    border: "1px solid #eee",
    borderRadius: 8,
    backgroundColor: "#fafafa",
    minHeight: 65,
  },

  licenciaCard: {
    border: "1px solid #eee",
    borderRadius: 8,
    padding: 12,
    backgroundColor: "#fafafa",
  },

  licenciaTitulo: {
    fontWeight: 600,
    marginBottom: 8,
    color: "#233463",
  },

  licenciaImagen: {
    objectFit: "cover",
    borderRadius: 6,
    border: "1px solid #ddd",
  },

  pdfCard: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    border: "1px solid #eee",
    borderRadius: 8,
    padding: 14,
    backgroundColor: "#fafafa",
  },

  sinLicencia: {
    padding: 14,
    borderRadius: 8,
    backgroundColor: "#fff7e6",
    border: "1px solid #ffd591",
    color: "#ad6800",
    fontWeight: 600,
  },
};